import React from "react";

export default function statusIcon(color){
	return (<svg id="Laag_4" viewBox="0 0 80 80">
		<g>
			<path fill={color} d="M50.584,22.658h-5.12H34.252h-5.12c-1.237,0-2.241,1.005-2.241,2.241v29.585
				c0,1.238,1.004,2.242,2.241,2.242h21.452c1.234,0,2.241-1.004,2.241-2.242V24.898C52.825,23.663,51.818,22.658,50.584,22.658
				M44.566,27.795h-9.419v-4.241h9.419V27.795z M45.464,28.692v-1.931h3.468v25.862H30.784V26.761h3.468v1.931H45.464z M51.93,54.484
				c0,0.742-0.604,1.346-1.346,1.346H29.132c-0.742,0-1.345-0.604-1.345-1.346V24.898c0-0.741,0.604-1.345,1.345-1.345h5.12v2.312
				h-4.364V53.52h19.94V25.865h-4.364v-2.311h5.12c0.741,0,1.346,0.604,1.346,1.345V54.484z"/>
			<path fill={color} d="M32.197,33.314c0,1.7,1.382,3.082,3.081,3.082c1.7,0,3.082-1.382,3.082-3.082
				c0-1.699-1.382-3.082-3.082-3.082C33.58,30.233,32.197,31.615,32.197,33.314 M35.278,31.129c0.468,0,0.899,0.151,1.254,0.401
				l-1.427,2.119l-1.05-1.108l-0.652,0.616l1.82,1.92l1.931-2.865c0.191,0.324,0.31,0.699,0.31,1.102c0,1.205-0.98,2.185-2.186,2.185
				s-2.185-0.98-2.185-2.185S34.073,31.129,35.278,31.129"/>
			<path fill={color} d="M35.278,37.684c-1.699,0-3.081,1.383-3.081,3.082c0,1.7,1.382,3.082,3.081,3.082
				c1.7,0,3.082-1.382,3.082-3.082C38.36,39.066,36.979,37.684,35.278,37.684 M35.278,42.95c-1.205,0-2.185-0.979-2.185-2.185
				c0-1.207,0.98-2.187,2.185-2.187c0.468,0,0.899,0.15,1.254,0.4L35.105,41.1l-1.05-1.107l-0.652,0.617l1.82,1.921l1.932-2.865
				c0.19,0.324,0.309,0.697,0.309,1.103C37.464,41.971,36.483,42.95,35.278,42.95"/>
			<path fill={color} d="M35.278,45.135c-1.699,0-3.081,1.383-3.081,3.082s1.382,3.08,3.081,3.08c1.7,0,3.082-1.381,3.082-3.08
				S36.979,45.135,35.278,45.135 M35.278,50.4c-1.205,0-2.185-0.979-2.185-2.185s0.98-2.186,2.185-2.186
				c0.468,0,0.899,0.149,1.255,0.399l-1.428,2.119l-1.05-1.107l-0.652,0.615l1.82,1.922l1.932-2.864
				c0.19,0.321,0.309,0.696,0.309,1.102C37.464,49.421,36.483,50.4,35.278,50.4"/>
			<rect x="39.615" y="31.841" fill={color} width="1.619" height="0.897"/>
			<rect x="39.615" y="33.892" fill={color} width="7.24" height="0.896"/>
			<rect x="39.615" y="39.293" fill={color} width="1.619" height="0.896"/>
			<rect x="39.615" y="41.343" fill={color} width="7.24" height="0.896"/>
			<rect x="39.615" y="46.742" fill={color} width="1.619" height="0.896"/>
			<rect x="39.615" y="48.794" fill={color} width="7.24" height="0.896"/>
		</g>
	</svg>);
}